module.exports = __webpack_public_path__ + "img/t10.352d051c.png";